import { Component, IValue, SetModel, SetView } from "vasille";



export class BaseBrick extends Component {
    x : IValue<number>;
    y : IValue<number>;
    tx : IValue<number>;
    ty : IValue<number>;
    l1x : IValue<number>;
    l1y : IValue<number>;
    l2x : IValue<number>;
    l2y : IValue<number>;
    step : IValue<number>;
    scale : IValue<number>;
    className : IValue<string>;
    cw : IValue<number>;
    ch : IValue<number>;

    cx : IValue<number>;
    cy : IValue<number>;
    lscale: IValue<number>;

    lWidth: IValue<number>;
    lHeight: IValue<number>;
    left: IValue<number>;
    right: IValue<number>;
    top: IValue<number>;
    bottom: IValue<number>;
    hVisible: IValue<boolean>;
    vVisible: IValue<boolean>;
    visible: IValue<boolean>;

    bigSquares: SetModel = new SetModel();
    mediumSquares: SetModel = new SetModel();
    smallSquares: SetModel = new SetModel();

    constructor () {
        super();

        this.x = this.$ref(0);
        this.y = this.$ref(0);
        this.tx = this.$ref(0);
        this.ty = this.$ref(0);
        this.l1x = this.$ref(0);
        this.l2x = this.$ref(0);
        this.l1y = this.$ref(0);
        this.l2y = this.$ref(0);
        this.step = this.$ref(0);
        this.scale = this.$ref(0);
        this.className = this.$ref(null);
        this.cw = this.$ref(0);
        this.ch = this.$ref(0);

        this.vl = this.$ref(0);

        for (let i = 0; i < 10; i++) {
            this.bigSquares.add({
                x: Math.random() * 30,
                y: Math.random() * 30,
                rotate: Math.random() * 90,
                step: i
            });
        }

        for (let i = 0; i < 40; i++) {
            this.mediumSquares.add({
                x: Math.random() * 35,
                y: Math.random() * 35,
                rotate: Math.random() * 90,
                step: i
            });
        }

        for (let i = 0; i < 50; i++) {
            this.smallSquares.add({
                x: Math.random() * 38,
                y: Math.random() * 38,
                rotate: Math.random() * 90,
                step: i
            });
        }
    }

    $created () {
        super.$created();

        this.cx = this.$bind(
            (x, l1x, l2x, step) =>
                step < 2 || step > 4
                ? x * step
                : step === 2
                  ? 2 * (x - l1x)
                  : 4 * (x - l2x),
            this.x, this.l1x, this.l2x, this.step
        );

        this.cy = this.$bind(
            (y, l1y, l2y, step) =>
                step < 2 || step > 4
                ? y * step
                : step === 2
                  ? 2 * (y - l1y)
                  : 4 * (y - l2y),
            this.y, this.l1y, this.l2y, this.step
        );

        this.lscale = this.$bind((scale, step) => scale / step, this.scale, this.step);

        this.lWidth = this.$bind(step => 40 * step, this.step);
        this.lHeight = this.$bind(step => 40 * step, this.step);
        this.left = this.$bind((x, scale, tx) => x * scale + tx, this.x, this.scale, this.tx);
        this.right = this.$bind((left, w, scale) => left + w * scale, this.left, this.lWidth, this.lscale);
        this.top = this.$bind((y, scale, ty) => y * scale + ty, this.y, this.scale, this.ty);
        this.bottom = this.$bind((top, h, scale) => top + h * scale, this.top, this.lHeight, this.lscale);
        this.hVisible = this.$bind((left, right, cw) => left < cw && right > 0, this.left, this.right, this.cw);
        this.vVisible = this.$bind((top, bottom, ch) => top < ch && bottom > 0, this.top, this.bottom, this.ch);
        this.visible = this.$bind((h, v) => h && v, this.hVisible, this.vVisible);
    }

    $compose () {
        super.$compose();

        this.$tag("div", div => {
            div.$bindMount(this.visible);
            div.$addClass("block");
            div.$bindClass(this.className);
            const styles = (
                {
                    "transform" : div.$bind(
                        (x, left, y, top, scale, step, v) => {
                            return !v ? "" :
                                   step <= 4
                                   ? "translate(" + x + "px, " + y + "px)"
                                   : "translate(" + left + "px, " + top + "px) scale(" + scale + ")";
                        },
                        this.cx, this.left, this.cy, this.top, this.lscale, this.step, this.visible),
                    "will-change": div.$bind(step => step > 4 ? "transform" : "", this.step)
                });
            for (let i in styles) {
                div.$style(i, styles[i]);
            }

            div.$tag("div", pdiv => {
                pdiv.$bindMount(div.$bind(vl => vl >= 1, this.vl));
                pdiv.$create(new SetView(this.bigSquares), $ => $.slot.insert((rni, item) => {
                    rni.$tag('div', div => {
                        const styles = ({
                            'transform': div.$bind((scale) => {
                                return 'translate(' + item.x * scale + 'px, ' + item.y * scale + 'px) rotate(' + item.rotate + 'deg)';
                            }, this.step),
                            'width': div.$bind(step => step * 0.35 + 'px', this.step),
                            'height': div.$bind(step => step * 0.35 + 'px', this.step)
                        });
                        for (let i in styles) {
                            div.$style(i, styles[i]);
                        }
                        div.$bindMount(pdiv.$bind((vl) => vl >= 3 + 0.1 * item.step, this.scale));
                    });
                }));
            });

            div.$tag("div", pdiv => {
                pdiv.$bindMount(div.$bind(vl => vl >= 2, this.vl));
                pdiv.$create(new SetView(this.mediumSquares), $ => $.slot.insert((rni, item) => {
                    rni.$tag('div', div => {
                        div.$addClass("medium");
                        const styles = ({
                            'transform': div.$bind((scale) => {
                                return 'translate(' + item.x * scale + 'px, ' + item.y * scale + 'px) rotate(' + item.rotate + 'deg)';
                            }, this.step),
                            'width': div.$bind(step => step * 0.15 + 'px', this.step),
                            'height': div.$bind(step => step * 0.15 + 'px', this.step)
                        });
                        for (let i in styles) {
                            div.$style(i, styles[i]);
                        }
                        div.$bindMount(pdiv.$bind((vl) => vl >= 9 + 0.15 * item.step, this.scale));
                    });
                }));
            });


            div.$tag("div", pdiv => {
                pdiv.$bindMount(div.$bind(vl => vl >= 3, this.vl));
                pdiv.$create(new SetView(this.smallSquares), $ => $.slot.insert((rni, item) => {
                    rni.$tag('div', div => {
                        const styles = ({
                            'transform': div.$bind((scale) => {
                                return 'translate(' + item.x * scale + 'px, ' + item.y * scale + 'px) rotate(' + item.rotate + 'deg)';
                            }, this.step),
                            'width': div.$bind(step => step * 0.05 + 'px', this.step),
                            'height': div.$bind(step => step * 0.05 + 'px', this.step)
                        });
                        for (let i in styles) {
                            div.$style(i, styles[i]);
                        }
                        div.$bindMount(pdiv.$bind((vl) => vl >= 17 + 0.2 * item.step, this.scale));
                    });
                }));
            });

        });
    }
}
